
class FbdClassPendingPreview {
   eGui;

   init(params) {
      const pending = params.value;
      this.eGui = document.createElement("span");

      if(Array.isArray(pending)) {
         const label = document.createElement("span");

         let ls;
         if(pending.length < 4) {
            ls = pending;
         }
         else {
            ls = pending.slice(0, 3);
            const exc = pending.length - 3;
            ls.push(`${exc} more...`);
         }

         label.innerText = ls.join(", ");

         this.eGui.appendChild(label);
      }
   }

   getGui() {
      return this.eGui;
   }

   refresh(params) {
      return false;
   }

   destroy() {

   }
}

export default FbdClassPendingPreview;